<script>
  import Common from '../../js/common.js';

  export let plays;
  export let top;
  export let bot;
</script>

<div class='game-plays' class:game-plays-top={top} class:game-plays-bot={bot}>
  {#each plays as play}
    <div class='game-plays-play'> {@html Common.escapeMarkdown(play)} </div>
  {/each}
</div>

<style>
  .game-plays {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .game-plays-play {
    line-height: 1.25;
  }

  .game-plays-top {
    background: var(--yellow-0);
  }

  .game-plays-bot {
    background: var(--blue-0);
  }

  :global(body.dark) .game-plays-top {
    background: var(--grey-9);
    color: var(--yellow-1);
  }

  :global(body.dark) .game-plays-bot {
    background: var(--grey-9);
    color: var(--blue-1);
  }
</style>
